import Vue from "vue";
import moment from 'moment'

export const formatSeconds = (Vue) => {
  Vue.filter("formatSeconds", function (data) {
    return this.utils$.fromatDate(data);
  });
};
export const toPrecision = (Vue) => {
  Vue.filter("toPrecision", function (data) {
    return parseFloat((data * 100).toPrecision(12)) + "%";
  });
};

export const dateFormat = (Vue) => {
  Vue.filter('dateFormat', function (data, pattern = 'yyyy-MM-DD HH:mm:ss') {
    return moment(data).format(pattern)
  })
}

export const discriminationNameFilter = (Vue) => {
  Vue.filter('discriminationNameFilter', function (data) {
    let discriminationName = ''
    const discrimination = parseFloat(data)
    if (discrimination <= 0.29) {
      discriminationName = '很差'
    } else if (discrimination >= 0.4) {
      discriminationName = '很好'
    } else {
      discriminationName = '一般'
    }
    return discriminationName
  })
};

export const degreeOfDifficultyNameFilter = (Vue) => {
  Vue.filter('degreeOfDifficultyNameFilter', function(data) {
    let degreeOfDifficultyName = ''
    const degreeOfDifficulty = parseFloat(data)
    if (degreeOfDifficulty < 0.2) {
      degreeOfDifficultyName = '偏难'
    } else if (degreeOfDifficulty > 0.6) {
      degreeOfDifficultyName = '偏易'
    } else {
      degreeOfDifficultyName = '适中'
    }
    return degreeOfDifficultyName
  })
};

